/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Button } from '@coursera/cds-core';

import _t from 'i18n!nls/account-settings';

export type Props = {
  className?: string;
  onClick: (ev: React.SyntheticEvent<any>) => void;
  text: string;
  updating?: boolean;
  disabled?: boolean;
};

class SaveButton extends React.Component<Props> {
  static defaultProps = {
    className: 'settings-primary-action',
  };

  render() {
    const { className, onClick, text, updating, disabled } = this.props;

    return (
      <Button className={className} variant="secondary" onClick={onClick} loading={updating} disabled={disabled}>
        {updating ? _t('Updating') : text}
      </Button>
    );
  }
}

export default SaveButton;
